export default __webpack_public_path__ + "images/6e0087adf379abe3c87ed6b3f2e71659.png";